module.exports = __webpack_public_path__ + "img/blindbox-title.dbe6b05d.png";